import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';

const Herosection8 = () => {
    const carouselItems = [
        {
            heading: 'Custom Software, Real Results - ',
            highlight: ' Your Partner in Digital Growth',
            text: 'Empowering your business with tailored solutions that deliver measurable success and sustainable growth',
        },
        {
            heading: 'Where Ideas Meet Execution - ',
            highlight: ' Tailored Software, Just for You',
            text: 'Bringing your unique business needs to life with precision and innovation',
        },
        {
            heading: 'Global Expertise, Local Pricing - ',
            highlight: ' Innovative Solutions Within Reach',
            text: 'Access world-class software development at competitive rates, without compromising on quality',
        },
    ];

    const handleClick = () => {
        window.scrollTo({left: 0, top: document.body.scrollHeight, behavior: 'smooth'});
    };

    return (
        <div className="row align-items-center">
            <div className="col-12 col-lg-5 col-xl-6 order-lg-2 mb-8 mb-lg-0">
                {/* Image */}
                <img src={require(`../../assets/images/hero/06.png`)} className="img-fluid" alt="..." />
            </div>
            <div className="col-12 col-lg-7 col-xl-6 order-lg-1">
                <OwlCarousel
                    className="owl-carousel no-pb"
                    dotData={false}
                    items={1}
                    autoplay={true}
                    margin={30}
                    dots={false}
                    loop={true}
                >
                    {carouselItems.map((item, index) => (
                        <div className="item" key={index}>
                            {/* Heading */}
                            <h1 className="display-4 font-w-6">
                                {item.heading}
                                <span className="text-primary">{item.highlight}</span>
                            </h1>
                            {/* Text */}
                            <p className="lead text-muted">{item.text}</p>
                            {/* Buttons */}
                            <Link to="/" className="btn btn-primary shadow me-1 mt-3" onClick={handleClick}>
                                Contact Us
                            </Link>
                        </div>
                    ))}
                </OwlCarousel>
            </div>
        </div>
    );
};

export default Herosection8;
